import React from 'react'
import { Large } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

interface ErrorMessageProps {
    /**
     * The main error message to display (e.g., "Failed to load Meta ads.")
     */
    message: string
    /**
     * Optional detail to append (e.g., error.message or "Please try again.")
     */
    detail?: string
    /**
     * Optional className for the container
     */
    className?: string
}

/**
 * ErrorMessage Component
 *
 * A reusable component for displaying error states in panels and modals.
 * Displays a centered message in destructive styling.
 *
 * @example
 * <ErrorMessage message="Failed to load Meta ads." detail="Please try again." />
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
    message,
    detail,
    className,
}) => {
    return (
        <div
            className={cn(
                'flex w-full flex-col items-center rounded-xl bg-destructive/5 py-12',
                className,
            )}
            role="alert"
            aria-live="assertive"
        >
            <Large className="text-center text-destructive">
                {message}
                {detail ? ` ${detail}` : ''}
            </Large>
        </div>
    )
}
